/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoLink_shipmentQuote = {
    readonly showQuoteAsPending: boolean | null;
    readonly " $refType": "PdpSharedShippingInfoLink_shipmentQuote";
};
export type PdpSharedShippingInfoLink_shipmentQuote$data = PdpSharedShippingInfoLink_shipmentQuote;
export type PdpSharedShippingInfoLink_shipmentQuote$key = {
    readonly " $data"?: PdpSharedShippingInfoLink_shipmentQuote$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_shipmentQuote">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoLink_shipmentQuote",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showQuoteAsPending",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};
(node as any).hash = '8fec3d0a66cf5b93f4e9409d01f51a92';
export default node;
